<template>
  <div id="mask">

  <div class="voucher-count">
    <!-- @close="VoucherClose" -->
    <el-dialog class="self-demo-dialog" center     :visible.sync="userInfoShow"        @close="close"  append-to-body>
     
      <el-form :model="formCode" :rules="rules" ref="formRef" label-width="120px" class="user-info-form" v-show="codeShow==0">
      <!-- 姓名输入 -->
      <el-form-item label="手机号" prop="phone">
        <el-input
          v-model="formCode.phone"
          placeholder="请输入手机号"
          clearable
          maxlength="11"
          show-word-limit
        />
      </el-form-item>
      <el-form-item label="抖音/快手" prop="other_info">
        <el-input
          v-model="formCode.other_info"
          placeholder="请输入抖音号或快手号"
          clearable
          show-word-limit
        />
      </el-form-item>
      <!-- 手机号输入 -->
      <el-form-item label="身份证后4位" prop="card">
        <el-input
          v-model="formCode.card"
          placeholder="请输入身份证后4位"
          clearable
          maxlength="4"
        />
      </el-form-item>
      
      <!-- 提交按钮 -->
      <el-form-item>
       <!-- <el-button class="sub-button"  @click="submitForm"></el-button> -->
         <!-- <el-button @click="resetForm">重置</el-button> -->
        <div class="sub-button" @click="submitForm"></div>
      </el-form-item>
    </el-form>

     <div class="code-content" v-show="codeShow==1">
          <div class="user-code">{{ code }} </div>
          <div class="copy-code" @click="copy(code)">复制主播码</div>
     </div>
    </el-dialog>

  

 </div>
   


</div>
</template>

<script>

import { getToken } from "@/utils/auth";
import { Notification } from "element-ui";
import orderApi from "../../../api/orderApi";



export default {
  // props: {
    name: 'UserInfoForm',
  // },
  data() {

// 手机号验证规则
const validatePhone = (rule, value, callback) => {
  var reg = /^1[3456789]\d{9}$/;
      if (reg.test(value)) {
        callback();
      } else {
        callback(new Error("机号码格式不正确"));
      }
    };

    return {
      userInfoShow:false,
      codeShow:0,
      code:'',
      formCode: {
        name: '',
        phone: '',
        other_info:'',
        token:getToken(),
      },
      rules: {
        card: [
          { required: true, message: '请输身份证后四位', trigger: 'blur' },
          { min: 2, max: 5, message: '长度在 2 到 5 个字符', trigger: 'blur' }
        ],
        other_info: [
          { required: true, message: '主播号或者快手号不为空', trigger: 'blur' },
          { min: 1, max: 1000, message: '长度在 1 到 1000 个字符', trigger: 'blur' }
        ],
        phone: [
          { required: true, validator: validatePhone, trigger: 'blur' }
        ]
      }
    };
    
  },

  computed: {
 

  },
  mounted() {
 
    this.getCode();

  
  },
 
  methods: {

    //关闭弹框
    close() {

      this.$emit("update:userInfoClose", false);
    },
 
    // // 提交表单
    async submitForm() {
      this.$refs.formRef.validate(async (valid) => {
        if (valid) {
          const params = Object.assign({}, this.formCode)
          const res = await orderApi.userInfoCode(params);
          if (res.result == 1) {
            this.$message.success(res.data);
            this.getCode();
          } 
      
        } else {
          this.$message.error('请检查表单填写是否正确');
          return false;
        }
      });
    },
   
    async getCode(){

      let params = { token: getToken()};
      const res = await orderApi.getUserInfoCode(params);
      if(getToken()!=undefined){
          if (res.result == 1) { 
            this.code=res.data.gift_code; 
            this.codeShow=1;
          }  
          }
    },

     // 一键复制
     async copy(content) {
      try {
        let res = await this.$utils.doCopy(content);
        Notification({
          title: res,
          offset: 50,
          customClass: "messageIndex",
          type: "success",
        });

        setTimeout(() => {
          this.dialogShow = false;
        }, 1000);
      } catch (error) {
        Notification({
          message: error,
          offset: 50,
          customClass: "messageIndex",
        });
      }
    },
  }
}
</script>

<style lang="scss" scoped>


.voucher-count{
  width: 100%;
  // justify-content: center;
  // align-items: center;
  // display: flex;
  // flex-direction: column;
  // align-items: center;
  ::v-deep .el-dialog--center{
     border: 1px solid;
     border-radius: 2%;
    }

}
//充值选择表单区域

.self-demo-dialog {

  position: fixed;


  ::v-deep .el-form-item__label {
    position: relative;
  }
  ::v-deep .el-dialog {
    width: 360px;
    height:300px;
    background-image: url('../../../assets/image/pc/order/anchor.png');
    background-size: 100% 100%;
    background-color: transparent;
    border-radius: 3%;
    -webkit-box-shadow: 0 1px 3px transparent;
    box-shadow: 0 1px 3px transparent;
    }
    ::v-deep .el-dialog_body{
      padding: 15px auto !important;
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
    // background-color: hsl(0, 99%, 0%);

    }
    ::v-deep .el-dialog__header {
      padding: 0px 10px 10px;
    }

  ::v-deep .el-form-item__label:before {
    display: inline-block;
    position: relative;
    top: 3px;
    left: -2px;;
    content: '' !important;
    width: 14px;
    height: 16px;
    background: url(../../../assets/image/pc/recharge/lx.png) no-repeat !important;
    background-size: 14px 16px !important;
  }
  ::v-deep  .el-form {
      // min-width: 400px;
      }
  ::v-deep  .el-form-item__label {
        width: 100%;
        font-size: 12px;
        font-weight: 600;
        color: #502d07;
  }
  
  ::v-deep  .el-input--suffix {
        width: 180px;

  }
  // .el-select-dropdown{
  //   width: 100%;
  //       font-size: 16px;
  //       font-weight: 600;
  //       color: #502d07;
  // }
   
    ::v-deep  .el-input__inner {
        height: 30px;
        // color: #000000;
        font-size: 12px;
      }  
    ::v-deep  .el-select-dropdown__list span {
      font-size: 12px;
    }
  
  // ::v-deep  .el-input {
  //       width: 100%;
  //       height: 40px;
  //       background-color: #fbf8f1;
  //       border-radius: 8px;
  //     }

}


//调整弹框的
    ::v-deep .el-dialog__body {
      padding: 15px auto !important;
      display: flex;
      justify-content: center;
      flex-direction: column;
      align-items: center;
    }
    ::v-deep .el-dialog__headerbtn .el-dialog__close{
      font-size: 45px;
       line-height: 1px;
       margin-right: -25px;
       color: #bd6242;

    }
   
    .user-info-form {
    max-width: 500px;
    margin-top: 40px;
      .sub-button{
        width: 80px;
        height:35px;
        margin-left: 1px;
        margin-top: -15px;
        background: url("~@/assets/image/pc/order/anchor-button.png") no-repeat
          center;
          background-size: 100% 100%;
      }
 
  }

  .code-content{
    max-width: 500px;
    margin-top: 13px;
    .user-code{
     width: 140px;
     height: 10px;
     margin-top:30px;
     font-size:20px;
     font-weight: 600;
     text-align: center;
     color: #514327;
    }
    .copy-code{
      max-width:100px;
      height:25px;
      margin-top:40px;
      text-align: center;
      font-size: 14px;
      line-height: 22px;
      color: #fff;
      background-color: #8eb6ea;
      border-radius: 5px;
      margin-left: 10px;
    }
    .copy-code:hover {
      cursor: pointer;
    }
  }




</style>
